import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import styled from "styled-components";

import Logo from "../../assets/copysmith-logo-26.png";
import CopySmithIcon from "../../assets/copysmith-workflow-large.png";
import AddSpacing from "../../components/AddSpacing";
import Input from "../../components/Input";

import { error } from "./SharedComponent";

const ContentDiv = styled.div`
  width: 100vw;
  position: absolute;
  left: 0px;
  top: 0px;
  display: flex;
  flex-direction: row;
  height: 100%;
  font-family: Futura;
`;

const MasterPanel = styled.div`
  width: 50%;
  height: 100vh;
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const LeftPanel = styled(MasterPanel)`
  background-color: #e4e7f5;
`;

const RightPanel = styled(MasterPanel)``;

const InnerContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const CopySmithIconContainer = styled.img`
  width: 100%;
  max-width: 500px;
`;

const CopySmithText = styled.div`
    color:#535CA5;
    font-family: Futura;
    font-weight: bold;
    font-size: 35px;
    max-width:400px;
    margin:auto
    padding-bottom:30px
`;

const LogoContainer = styled.img`
  position: absolute;
  top: 35px;
  left: 35px;
  height: 40px;
`;

const InnerContentRight = styled(InnerContent)`
  width: 100%;
  max-width: 800px;
  align-items: flex-start;
  margin: auto;
`;

const Overlay = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  background-color: black;
  opacity: 0.7;
`;

const Modal = styled.div`
  border-radius: 5px;
  background-color: white;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: 20px;
  z-index: 2000;
  font-family: Open Sans, san-serif;
`;

const GuardModal = ({ grantAcess }) => {
  const [accessCode, setAccessCode] = useState("");

  const submit = (event) => {
    event.preventDefault();
    if (accessCode === "Copysmith") {
      grantAcess();
    } else {
      error("Wrong access code.");
      setAccessCode("");
    }
  };

  return (
    <>
      <Overlay></Overlay>
      <Modal className="fadeIn">
        <AddSpacing spacing={20}>
          <div style={{ color: "red", fontSize: 25 }}>
            We are in private beta
          </div>
          <div>An access code is required to authenticate</div>
          <form onSubmit={submit}>
            <Input
              onChange={(e) => setAccessCode(e.target.value)}
              value={accessCode}
              style={{ borderRadius: 5 }}
            />
          </form>
          <Link to="/">Go back to landing page</Link>
        </AddSpacing>
      </Modal>
    </>
  );
};

const Authentication = ({ children }) => {
  const history = useHistory();
  const [access, setAccess] = useState(false);

  return (
    <ContentDiv>
      {!access && <GuardModal grantAcess={() => setAccess(true)} />}
      <LeftPanel>
        <InnerContent>
          <CopySmithText>
            Compelling posts with 10 seconds of work.
          </CopySmithText>
          <CopySmithIconContainer src={CopySmithIcon} />
        </InnerContent>
      </LeftPanel>
      <RightPanel>
        <InnerContentRight>
          <AddSpacing>{children}</AddSpacing>
        </InnerContentRight>
      </RightPanel>
      <LogoContainer
        src={Logo}
        onClick={() => history.push("/")}
        style={{
          cursor: "pointer",
        }}
      />
    </ContentDiv>
  );
};
export default Authentication;
